import AppHeader from "../../layout/AppHeader";
import ShippingPage from '../../xpost/views/register/shipping/ShippingPage.vue';
import ShippingAdd from '../../xpost/views/register/shipping/ShippingAdd.vue';
import ShippingSequencePage from '../../xpost/views/register/shipping/ShippingSequencePage.vue';
import ShippingIntegrationPage from '../../xpost/views/register/shipping/ShippingIntegrationPage.vue';
import ShippingIntegrationAdd from '../../xpost/views/register/shipping/integration/ShippingIntegrationAdd.vue';

const ShippingRoutes = [
    {
        path: "/cadastro/transportadora",
        name: "shipping",
        meta: {
            role: ['1', '3'],
        },
        components: {
            header: AppHeader,
            default: ShippingPage
        }
    },
    {
        path: "/cadastro/transportadora/adicionar",
        name: "shipping.add",
        meta: {
            role: ['1', '3'],
        },
        components: {
            header: AppHeader,
            default: ShippingAdd
        }
    },
    {
        path: '/cadastro/transportadora/adicionar/:id',
        name: 'shipping.edit',
        meta: {
            role: ['1', '3'],
        },
        components: {
            header: AppHeader,
            default: ShippingAdd
        }
    },
    {
        path: '/cadastro/transportadora/sequencia',
        name: 'shipping.sequence',
        meta: {
            role: ['1', '3'],
        },
        components: {
            header: AppHeader,
            default: ShippingSequencePage
        }
    },
    {
        path: '/cadastro/transportadora/integracao',
        name: 'shipping.integration',
        meta: {
            role: ['1'],
        },
        components: {
            header: AppHeader,
            default: ShippingIntegrationPage
        }
    },
    {
        path: '/cadastro/transportadora/editar',
        name: 'shipping.integration.edit',
        meta: {
            role: ['1'],
        },
        components: {
            header: AppHeader,
            default: ShippingIntegrationAdd
        }
    }

]

export default ShippingRoutes;